var module = angular.module('octopusApp.configuration');

module.controller('UserRoleIndexController', function($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.UserRoles.list().then(function (results) {
    $scope.roles = results;
  }));
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/roles/controllers/user_role_index_controller.js
// module id = 6514273403749635
// module chunks = 1